import { Component, OnInit, Input, Inject } from '@angular/core';
import { APIService, myCurrency } from '../../api.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services/common.service';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CategoriesComponent } from '../../inventory/categories/categories.component';
import { StoresComponent } from '../stores/stores.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';
import { SubCategoriesComponent } from '../sub-categories/sub-categories.component';
import { DataService} from 'src/app/services/data.service';
import { BatchSelectionComponent } from '../batch-selection/batch-selection.component';
import { UnitsComponent } from '../units/units.component';
import { DeviceDetectorService } from 'ngx-device-detector';


@Component({
  selector: 'app-item-entry',
  templateUrl: './item-entry.component.html',
  styleUrls: ['./item-entry.component.scss']
})
export class ItemEntryComponent implements OnInit {

  openFromWindowPopup: any = this.CmnService.GetParam('S');
  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();

  window: any = "";
  myControl = new FormControl();
  categoryCtrl = new FormControl();
  subCategoryCtrl = new FormControl();
  unitCtrl = new FormControl();
  StoreCtrl = new FormControl();
  HSNCtrl = new FormControl();
  TagCtrl = new FormControl();
  batchCtrl = new FormControl();
  impItemCtrl = new FormControl();
  categoryList: any = [];
  orgCategotyList: any = [];
  isRateEdit: boolean = false;
  isShowPropose: boolean = false;
  isShowCatWiseRateBtn: boolean = false;
  closeResult: string = '';
  isAddCate: boolean = true;
  enableMRP: boolean = false;
  isB2C: boolean = false;

  filteredCategory!: Observable<category[]>;
  filteredsubCategoryList!: Observable<subCategory[]>;
  filteredUnit!: Observable<units[]>;
  filterStore!: Observable<store[]>;
  filterHSN!: Observable<HSN[]>;
  filterTag!: Observable<Tags[]>;
  filterBatch!: Observable<BatchType[]>;
  filterImportance!: Observable<itemImportant[]>;

  
  commonService: any;
  CommonService: any;

  constructor(private apiService: APIService, private http: HttpClient, private activeModal: NgbActiveModal, private modalService: NgbModal,private dataSer: DataService,
    public CmnService: CommonService,private loadingPnl: NgxSpinnerService, private deviceService: DeviceDetectorService,
    @Inject(DOCUMENT) private document: Document) {
      this.window = this.document.defaultView;
  }

  @Input() BasicData: any;
  @Input() mdlRef: any;
  @Input() fromItemEntry: boolean = false;	

  barcodeOptions = {
    showCode: true,
    showName: false,
    showPrice: false,
    count: 1,
    showMRP: false
};
  modalReference: any;
  modeType: any = 1;
  subCategoryList: subCategory[] = [];
  categories: category[] = [];
  store: store[] = []
  UnitList: units[] = [];
  storeList: store[] = [];
  hsnList: HSN[] = [];
  mainTagList: Tags[] = [];
  tempTagList: any = [];
  transactionDone: boolean = false;
  isExpirableBatch: boolean = false;
  gstRate = 0;
  isMobileView: boolean = this.deviceService.isMobile();

  batchType : Array<any> = [
    { ID: 0, type: 'No' },
    { ID: 1, type: 'Yes' },
    { ID: 2, type: 'Yes, Expirable' }
  ];
  itemImportant : Array<any> = [
    { ID: 0, itemType: 'Low' },
    { ID: 1, itemType: 'High' },
    { ID: 2, itemType: 'Normal' }
  ];

  data: any = {
    ItemName: '',
    ItemID: 0,
    code: '',
    typeID: 1,
    categoryID: 0,
    subCategory: '',
    SubCategoryID: 0,
    category: '',
    Qty: '',
    Unit: 'no.s',
    purchaseCost: '',
    salePrice: '',
    stockRate: '',
    minStockQty: '',
    isAvailable: true,
    showOnline: true,
    isActive: true,
    importanceID: 1,
    HSN: '',
    HSNId: 0,
    brochureLink: '',
    fileLink: '',
    description: '',
    tag: '',
    leadTime: '',
    prcn: 0,
    storeName: '',
    storeID: '',
    IsMade: true,
    IsPurchased: false,
    HsnPer: '',
    internalNotes: '',
    batchType: 'No',
    batchTypeID: 0,
    IMPTtemTyp: 'Normal',
    IMPItemID: 0,
    categoryRates: '[]',
    batches: '[]',
    mrpRate: '',
    mrpPrice: '',
    initQty: '',
    initUnit: ''
  };

  storeBatches: any = [{}];
  jarvisData: any = [];
  agencyData: any = [];
  codeChange = false;
  isEdit = false;
  tagList: any = [];
  IsDisable: boolean = false;
  stockList: any = [];
  prevItemCode: any;
  checkEdition: any;
  isClosSettingShow = false
  myCurrency: any = myCurrency();
  isIndian: boolean = false;
  rights: any;
  isRateView: boolean = false;
  isERPGold: boolean = true;
  batchList: any = [];
  totalBatchQty : number = 0;
  financialYears: any = [];
  CurrfinancialYears: any = [];
  isShowBatch: boolean = false;
  tmpBatchData: any;
  ERP_Agn: Array<any> = [];
  acctStartDT: Date = new Date();
  isERPGoldBatches: boolean = false;
  isWeb: boolean = false;
  isMRPChanged = false;
  showItemImage: boolean = false;
    //Upload File - Declaration	
    fileToUpload: any;	
    fileUpload: any = {	
      val: ""	
    }	
  fileData: any;	
  fileName: any;
  hasImg: boolean = false;
  win: any = "";
  timer: any;
  // currentDate: any = new Date();
  showAsPage: boolean = false;
  expand = {
    extraDetails: false
  };

  ngOnInit(): void {
    const savedOptions = this.apiService.getCookie('barcodeOptions');
    if (savedOptions) {
      this.barcodeOptions = JSON.parse(savedOptions);
    }
    if(this.openFromWindowPopup == 1){
      this.isClosSettingShow = true;
    }
    if(this.openFromWindowPopup == 2) {
      // this.isClosSettingShow = false;
      this.showAsPage = true;
    }
    
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      if(this.agencyData.length > 0){
        this.isIndian = this.agencyData[0].CC == 91 ? true : false;
        this.checkEdition = this.agencyData[0].EdnTID;
        this.enableMRP = this.agencyData[0].EMRP;
        this.isB2C = this.agencyData[0].IsB2C;

        if ([8, 17, 24, 31, 34, 35, 36, 37, 38].includes(this.checkEdition)) {
          this.showItemImage = true;
        }
      }
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    this.rights = this.apiService.getCookie("J");
    if(this.rights){
      this.rights = JSON.parse(this.rights);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.rights = $.grep(this.rights, function(o: any){ return o.UserID == ownUserID })[0];

      if(this.rights.InvRateView.toString()  != "undefined"){
          this.isRateView = this.rights.InvRateView
       }
    }
    this.isWeb = this.apiService.apiCheckWeb();
    // this.checkEdition = this.apiService.getCookie("selEdn");
    // if (this.checkEdition == 8) {
    //   this.isERPGold = true;
    // }

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    let isEnableAcc = false;
    //let isEnableBatches = false;
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }
    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
      isEnableAcc = this.ERP_Agn[0].EnblAccounts;
      this.isERPGoldBatches = this.ERP_Agn[0].EnblBatches;
    }
    if(this.isERPGoldBatches == true)
    {
    
      if(this.acctStartDT != null || this.acctStartDT != undefined  && isEnableAcc == true  && this.isERPGoldBatches == true)
      {
        let firstFinaicalYear  = this.CmnService.checkFinancialYear(this.acctStartDT, new Date());
        if(firstFinaicalYear){
          this.financialYears = firstFinaicalYear[0].FY;
        }
         //let currentDate = new Date()
        let CurrfinancialYears: any = this.CmnService.getCurrentFinancialYear(new Date());
        if(CurrfinancialYears == this.financialYears)
        {
          this.isShowBatch = true;
  
        }
        console.log( this.financialYears)
      }
    }
   
    // this.dataSer.batches.subscribe((value: any) => {
    //   debugger
    //   if(value.batchList.length > 0)
    //   this.batchList  = value.batchList;
    // });
   
    this.getAllUnits();
    this.getInvList();
    this.getPrevCode();
    this.getRelCategories();
  }

  openBatchSelectionMdl(content: any) {
    this.dataSer.batches.subscribe((value: any) => {
      if(value.batchList && value.batchList.length > 0)
      this.batchList  = value.batchList;
    });
   
    this.modalReference = this.modalService.open(BatchSelectionComponent, { windowClass : "BatchSelection", backdrop: 'static', keyboard: false});
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    let tempBatchTyp = this.batchType.filter((b: any) => b.type == this.data.batchType);
    if(tempBatchTyp.length > 0)
    {
      this.data.batchTypeID = tempBatchTyp[0].ID;
    }
    this.modalReference.componentInstance.batchTypeID = this.data.batchTypeID;
    this.tmpBatchData = [];
    if(this.batchList.length > 0 || this.batchList != '[]' || this.batchList != undefined ){
      this.tmpBatchData = this.batchList;//JSON.stringify(this.batchList);
      this.modalReference.componentInstance.batchesList = this.batchList;
    }
    else{
      this.tmpBatchData = [];
    }
    let tmpBatchDataList = {
      ItemID: 0,
      BatchType: this.data.batchTypeID,
      SKU:this.data.Unit,
      Prcsn: this.data.prcn,
      Batches: this.tmpBatchData,
      transferQty: this.data.Qty,
      isFrom: 'isFromItemEntry'
    };
    this.dataSer.updateByProduct(tmpBatchDataList);
  }

  //Get prev code
  getPrevCode() {
    let prevAgencyConfig = this.apiService.getCookie('Cfg_AgnCfg');
    if (prevAgencyConfig) {
      let finalConf: any = prevAgencyConfig;
      finalConf = JSON.parse(prevAgencyConfig);
      if (finalConf.length > 0) {
        this.prevItemCode = finalConf[0].LastItemCode;
      }
    }
  }
  //auto complete category
  private _filterCategory(value: string): category[] {
    const filterValue = value.toLowerCase();
    return this.categories.filter(state => state.cnm.toLowerCase().indexOf(filterValue) === 0);
  }

  //auto complete subcategory
  private _filterSubcategory(value: string): subCategory[] {
    const filterValue = value.toLowerCase();
    return this.subCategoryList.filter(state => state.snm.toLowerCase().indexOf(filterValue) === 0);
  }


  //auto complete Units
  private _filterUnit(value: string): units[] {
    const filterValue = value.toLowerCase();
    return this.UnitList.filter(state => state.UNm.toLowerCase().indexOf(filterValue) === 0);
  }

  //auto complete Units
  private _filterStore(value: string): store[] {
    const filterValue = value.toLowerCase();
    return this.storeList.filter(state => state.sNm.toLowerCase().indexOf(filterValue) === 0);
  }

  //auto complete HSN
  private _filterHSN(value: string): HSN[] {
    const filterValue = value.toLowerCase();
    return this.hsnList.filter(state => state.H.toLowerCase().indexOf(filterValue) === 0);
  }


  //auto complete Tag
  private _filterTag(value: string): Tags[] {
    const filterValue = value.toLowerCase();
    return this.mainTagList.filter(state => state.Tnm.toLowerCase().indexOf(filterValue) === 0);
    //return this.tempMainTagList.filter(state => state.Tnm.toLowerCase().indexOf(filterValue) === 0);
  }

  //auto complete Batch type
  private _filterBatch(value: string): store[] {
    const filterValue = value.toLowerCase();
    return this.batchType.filter(state => state.type.toLowerCase().indexOf(filterValue) === 0);
  }
  //auto complete Batch type
  private _filterImportance(value: string): itemImportant[] {
    const filterValue = value.toLowerCase();
    return this.itemImportant.filter(state => state.itemType.toLowerCase().indexOf(filterValue) === 0);
  }

  getInvList() {
    // Old code - using localStorage with encoding
    // let tempStockList = this.apiService.getZipCookie('erp_inv');
    // if (tempStockList) {
    //   this.stockList = JSON.parse(tempStockList);
    // }
    
    // New code - using IndexedDB without encoding
    this.apiService.getIDB('erp_inv', (erpInvData: any) => {
      if (erpInvData && erpInvData.length > 0) {
        this.stockList = erpInvData;
      }
    });
  }

  //open Categories
  open() {
    this.modalReference = this.modalService.open(CategoriesComponent, { windowClass: 'modal-category-Entry', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if (result.action == 'Done') {
        this.getAllUnits();
        //category List
        let cnfg;
        cnfg = this.apiService.getCookie('ERP_Cfg');
        if (cnfg) {
          cnfg = JSON.parse(cnfg);
          if (cnfg.length > 0) {
            this.categories = JSON.parse(cnfg[0].ItemCategories)
            this.categories = this.categories.sort((a: any, b: any) => a.cnm.localeCompare(b.cnm))
            this.getPrevCode();
          }
        }
        this.selectCategory();
      }
    })
  }



  //edit data
  editData() {
    if (this.BasicData) {
      let tempsubCat: any = []; 
      let categoryName: string = '';
      let categoryID: number = 0;
      let subCategoryName: string = '';
      let SubCategoryID: number = 0;
      // let category = $.grep(this.categories, function(o: any){ return o.cid == this.BasicData.CategoryID})
      let category = this.categories.filter((x: any) => x.cid == this.BasicData.CategoryID);
      if(category.length > 0){
        let subCategory = category[0].sub.filter((x: any) => x.sid == this.BasicData.SubCategoryID);
        if(subCategory.length > 0){
          subCategoryName = subCategory[0].snm;
          SubCategoryID = this.BasicData.SubCategoryID
        }
        categoryID = this.BasicData.CategoryID;
        categoryName = category[0].cnm;
      }
      else{
        categoryID = 0;
        categoryName = '';
      }

      this.modeType = this.BasicData.TypeID ? Number(this.BasicData.TypeID) : 1;
      let storeList = this.categories.filter((x: any) => x.cid == this.BasicData.CategoryID);
      let batchType = this.batchType.filter((x: any) => x.ID == this.BasicData.BatchType);
      let IMPItem = this.itemImportant.filter((b: any) => b.ID == this.BasicData.ImportanceID);
      if(IMPItem.length > 0){
        this.data.IMPTtemTyp  = IMPItem[0].itemType
      }

      // this.BasicData.MRPRate = ((this.BasicData.DefSaleRate) * (1 + (this.BasicData.DefGSTRate / 100))).toFixed(2);

      let temptags = this.BasicData.Tags
      this.tagList = temptags.split(',')
      this.tagList.pop();
      this.transactionDone = this.BasicData.XnIDs ? true : false;
      this.data = {
        ItemName: this.BasicData.ItemName,
        ItemID: this.BasicData.ItemID,
        code: this.BasicData.ItemCode,
        typeID: this.BasicData.TypeID,
        categoryID: categoryID, //this.BasicData.CategoryID,
        subCategory: subCategoryName, //subCategory.length > 0 ? subCategory[0].snm : '',
        SubCategoryID: SubCategoryID, //this.BasicData.SubCategoryID,
        category: category.length > 0 ? category[0].cnm : '',
        Qty: this.BasicData.CurrQty,
        Unit: this.BasicData.SKU,
        purchaseCost: this.BasicData.DefPurchRate,
        salePrice: this.BasicData.DefSaleRate,
        stockRate: this.BasicData.DefStockRate,
        minStockQty: this.BasicData.MinStockQty,
        isAvailable: true,
        showOnline: true,
        isActive: this.BasicData.IsActive,
        importanceID: this.BasicData.ImportanceID,
        HSN: this.BasicData.HSN,
        HSNId: this.BasicData.HSNID,
        brochureLink: '',
        fileLink: '',
        description: this.BasicData.Details,
        tag: '',
        leadTime: this.BasicData.LeadTime,
        prcn: this.BasicData.SKUPrecision,
        storeName: '',
        storeID: JSON.parse(this.BasicData.StoreBatches)[0].SID,
        IsMade: this.BasicData.IsMade,
        IsPurchased: this.BasicData.IsPurchased,
        HsnPer: this.BasicData.DefGSTRate, //this.BasicData.DefGSTRate == 0 ? '' : this.BasicData.DefGSTRate,
        internalNotes: this.BasicData.InternalNotes,
        batchType: batchType.length > 0 ?  batchType[0].type : 'No',
        IMPTtemTyp: this.data.IMPTtemTyp ? this.data.IMPTtemTyp : 'Normal',
        batches: this.BasicData.Batches ? this.BasicData.Batches : '[]',
        categoryRates: this.BasicData.CtgRates ? this.BasicData.CtgRates : '[]',
        batchTypeID: this.BasicData.BatchType,
        mrpRate: this.BasicData.MRPRate,
        mrpPrice: this.BasicData.MRPPrice ? this.BasicData.MRPPrice : 0
      }

      this.isEdit = true;

      if (this.BasicData.DefGSTRate && this.BasicData.HSN) {
        this.IsDisable = true
      }
      this.selectCategory();
    }
  }

  getCode = (obj: any) => {
    if(this.isEdit == true){
      if (String(this.data.ItemName).length < 30 && this.codeChange) {
        this.data.code = obj
      }
    }
    else if(this.isEdit == false){
      if (String(this.data.ItemName).length < 30 && !this.codeChange) {
        this.data.code = obj
      }
    }
    else
    {
      if (String(this.data.ItemName).length < 30 && !this.codeChange) {
        this.data.code = obj
      }
    }
  }

  funCodeChange = () => {
    if (String(this.data.code).length > 4) {
      this.codeChange = true;
    }
  }

  //def. stock rate
  changeStockRate = (obj: any) => {
    if (!this.isEdit) {
      if(this.data.salePrice == "" && this.data.purchaseCost == "" && this.data.mrpRate == ""){
        this.data.purchaseCost = this.data.stockRate; //obj;
        this.data.salePrice = this.data.stockRate; //obj;
        this.data.mrpRate = ((this.data.salePrice) * (1 + (this.data.HsnPer / 100))).toFixed(2);
        this.enterStockRate();
      }
    }
  }

  //tag value
  chagetagValue = () => {
    if (this.data.tag) {
      let count = 0;
      for (let i = 0; i <= String(this.data.tag).length; i++) {
        if (String(this.data.tag)[i] == ",") {
          count = count + 1
        }
        if (count > 0) {
          this.data.tag = this.data.tag.slice(0, this.data.tag.length - 1);
        }
      }
    }
  }

  //select category
  selectCategory = () => {
    setTimeout(() => {
      this.subCategoryList = [];
      if (this.data.category) {
        let tempCat = this.categories.filter((x: any) => x.cnm?.toString().trim().toLowerCase() == this.data.category.toString().trim().toLowerCase())
        if (tempCat.length > 0) {
          this.data.categoryID = tempCat[0].cid;
          this.data.category = tempCat[0].cnm.toString().trim();
          this.subCategoryList = tempCat[0].sub;
          this.subCategoryList = this.subCategoryList.sort((a: any, b: any) => a.snm.localeCompare(b.snm))

          this.filteredsubCategoryList = this.subCategoryCtrl.valueChanges
            .pipe(startWith(''), map(employee => employee ? this._filterSubcategory(employee) : this.subCategoryList.slice()));

        } else {
          this.apiService.successAlert("Please configure item categories.")
          this.data.category = '';
          this.subCategoryList = [];
          this.data.subCategory = '';
          this.data.categoryID = 0;
        }
      }
      else {
        this.data.category = '';
        this.subCategoryList = [];
        this.data.subCategory = '';
        this.data.categoryID = 0;
      }
    }, 200);

  }

  //select subCategory
  selectSubCategory = () => {
    setTimeout(() => {
      if (this.data.subCategory) {
        let tempsubCat: any = [];
        tempsubCat = this.subCategoryList.filter((x: any) => x.snm?.toString().trim().toLowerCase() == this.data.subCategory.toString().trim().toLowerCase())

        if (tempsubCat.length > 0) {
          this.data.SubCategoryID = tempsubCat[0].sid
          this.data.subCategory = tempsubCat[0].snm.toString().trim();
        }
        else {
          this.apiService.successAlert("Please configure item categories.")
          this.data.subCategory = '';
          this.data.SubCategoryID = 0;
        }
      }
    }, 200);
  }

  //unit select
  selectUnit = () => {
    setTimeout(() => {
      let cnfg;
      cnfg = this.apiService.getCookie('ERP_Cfg');
      if (cnfg) {
        cnfg = JSON.parse(cnfg);
        if (cnfg.length > 0) {
          this.UnitList = JSON.parse(cnfg[0].Units);
          this.UnitList = this.UnitList.sort((a: any, b: any) => a.UNm.localeCompare(b.UNm));
        }
      }
      if (this.data.Unit) {
        let tempUnit = this.UnitList.filter((x: any) => x.UNm == this.data.Unit);
        if (tempUnit.length > 0) {
          this.data.prcn = tempUnit[0].Prcsn
          this.prcnQty();
        }
        else {
          this.data.prcn = 0;
          this.data.Unit = ""
          this.apiService.successAlert("Please configure units.")
        }
      }
    }, 200);

  }

  //get batchses type
  getBatchType = () => {
    if(this.data.batchType == "Yes, Expirable" || this.data.batchType == "Yes")
    {
      this.isExpirableBatch = true;
    }
    else{
      this.isExpirableBatch = false;
    }
    this.data.batchTypeID = this.data.batchType == "Yes, Expirable" ? 2 : this.data.batchType == "Yes" ? 1 : 0
  }
    //get batchses type
    getIMPItems = () => {
      if (this.data.IMPTtemTyp) {
        let tempIMPItem = this.itemImportant.filter((x: any) => x.itemType == this.data.IMPTtemTyp);
        if(tempIMPItem.length > 0){
          this.data.IMPTtemTyp = tempIMPItem[0].itemType
        }
      }
    }
  //qty with prcn
  enterQty = () => {
    this.data.Qty = this.CmnService.PrecisionwiseValue(this.data.Qty, this.data.prcn)
  }

  prcnQty() {
    this.data.Qty = Number(this.data.Qty).toFixed(this.data.prcn)
  }

  //stock with prcn
  enterStockRate = () => {
    this.data.stockRate = this.CmnService.PrecisionwiseValue(this.data.stockRate, 4)
    this.data.purchaseCost = this.CmnService.PrecisionwiseValue(this.data.purchaseCost, 4)
    this.data.salePrice = this.CmnService.PrecisionwiseValue(this.data.salePrice, 4)
    // this.data.mrpRate = this.CmnService.PrecisionwiseValue(this.data.mrpRate, 4)
    // if(this.enableMRP)
    // {
    //   this.gstRate = Number(this.data.HsnPer);
    //   this.data.mrpRate = Number(this.data.salePrice * this.gstRate);
    //   this.data.mrpRate = Number(((Number(this.data.mrpRate) / 100) + Number(this.data.salePrice)).toFixed(2));
    //   //this.fn_changeMRPRate();
    // }
    

  }


  // //purchaseCost with prcn
  // enterPurchaseCost = () => {
  //   this.data.purchaseCost = this.CmnService.PrecisionwiseValue(this.data.purchaseCost, this.data.prcn)
  // }

  // prcnPurchRate() {
  //   this.data.purchaseCost = Number(this.data.purchaseCost).toFixed(this.data.prcn)
  // }


  // //salePrice with prcn
  // entersaleCost = () => {
  //   this.data.salePrice = this.CmnService.PrecisionwiseValue(this.data.salePrice, this.data.prcn)
  // }

  // prcnsaleRate() {
  //   this.data.salePrice = Number(this.data.salePrice).toFixed(this.data.prcn)
  // }

  //select store
  selectStore = () => {
    let tempStore = this.storeList.filter((x: any) => x.sNm == this.data.storeName);
    if (tempStore.length > 0) {
      this.data.storeID = tempStore[0].StrID
    }
    else {
      this.data.storeID = 0;
      this.data.storeName = ""
    }
  }

  //select HSN
  selectHSN() {
    this.IsDisable = false
    this.data.HsnPer = ''
    let tempHsn = this.hsnList.filter((x: any) => x.H == this.data.HSN);
    if (tempHsn.length > 0) {
      this.data.HSNId = tempHsn[0].HID
      this.data.HsnPer = tempHsn[0].Per
      this.data.mrpRate = ((this.data.salePrice) * (1 + (this.data.HsnPer / 100))).toFixed(2);
      this.IsDisable = true
    }

  }

  //tag Entry
  tagEntry = () => {
    if(!this.data.tag){
        return;
    }
    var flag = false;
    //var value = this.data.tag.toUpperCase();
    if (this.tagList) {
      for (var i = 0; i < this.tagList.length; i++) {
        if (this.data.tag.toUpperCase() == this.tagList[i].toUpperCase()) {
          flag = true
          break;
        }
        //this.tempTagList.push(this.mainTagList[i].Tnm.toUpperCase());
      }
    }
    if (!flag) {
      this.tagList.push(this.data.tag)
      this.data.tag = '';
    }
    else {
      this.apiService.successAlert('This tag already exists.');
      this.data.tag = '';
    }
  }

  //change mode
  changeMode(obj: any) {
    this.modeType = Number(obj);
    this.data.typeID = obj;

    if (this.data.typeID == '1' || this.data.typeID == '4') {
      this.data.IsMade = true;
      this.data.IsPurchased = false;

    }

    if (this.data.typeID == '2') {
      this.data.IsPurchased = true;
      this.data.IsMade = false;

    }

  }

  //save - save item
  save() {
    debugger
    if(this.isEdit){
      if(this.data.batches || this.data.batches != '[]'){
        let dBBatches = JSON.parse(this.data.batches)
        if(dBBatches.length > 0)
        {
          this.batchList = dBBatches;
        }
      }
    }
    if((this.data.batchTypeID == 1 || this.data.batchTypeID == 2))
    {
      
      var sum = 0;
      for(let i = 0; i < this.batchList.length; i++){  
        // sum = sum + this.batchList[i].Q;
        sum = Number(this.CmnService.PrecisionwiseValue((Number(sum) + Number(this.batchList[i].Q)).toFixed(this.data.prcn), this.data.prcn));
        sum = Number(this.CmnService.PrecisionwiseValue(sum.toFixed(this.data.prcn), this.data.prcn));
      }
      this.totalBatchQty = sum;
    }
    else {
      this.batchList = [];
    }
    var itemQty = Number(this.CmnService.PrecisionwiseValue(Number(this.data.Qty).toFixed(this.data.prcn), this.data.prcn));
     //Get Batches data and sum of all batches QTY
    var tag = '';
    for (let i = 0; i < this.tagList.length; i++) {
      tag = tag + this.tagList[i].trim() + ","
    }

    this.storeBatches = [{
      "SID": this.data.storeID, "Q": this.data.Qty, "B": []
    }]

    let tempBatchTyp = this.batchType.filter((b: any) => b.type == this.data.batchType);
    if(tempBatchTyp.length > 0)
    {
      this.data.batchTypeID = tempBatchTyp[0].ID;
    }
    let tempIMPItem = this.itemImportant.filter((b: any) => b.itemType == this.data.IMPTtemTyp);
    if(tempIMPItem.length > 0)
    {
      this.data.importanceID = tempIMPItem[0].ID;
    }

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")

    let duplicateCode = this.stockList.filter((x: any) => (x.ItemCode == this.data.code || x.ItemName == this.data.ItemName) && x.ItemID != this.data.ItemID)
    if (duplicateCode.length > 0) {
      this.apiService.successAlert('Another item with this name or code already exists.');
      return;
    }

    //Validation
    if (this.data.ItemName == "") {
      this.apiService.successAlert('Please enter item name.');
      return;
    }

    else if (this.data.code == "") {
      this.apiService.successAlert('Please enter item code.');
      return;
    }

    if (this.data.category == "" && this.data.subCategory == "") {
      let tempCat = this.categories.filter((x: any) => x.cnm == "-")
      if (tempCat.length > 0) {
        let subCtgList = tempCat[0].sub;
        
        let tempsubCat = subCtgList.filter((x: any) => x.snm == "-")
        if (tempsubCat.length > 0) {
          this.data.category = "-"; 
          this.data.categoryID = tempCat[0].cid;
          this.data.subCategory = "-";
          this.data.SubCategoryID = tempsubCat[0].sid
        }
      }
    }

    if (this.data.category == "") {
      this.apiService.successAlert('Please select a category.');
      return;
    }

    else if (this.data.subCategory == "") {
      this.apiService.successAlert('Please select a sub-category.');
      return;
    }

    else if ((this.data.Qty == '') && (this.data.Qty != 0)) {
      this.apiService.successAlert('Please enter quantity of this item.');
      return;
    }
    else if ((this.isShowBatch == true && this.data.batchTypeID == 1 || this.data.batchTypeID == 2) && (Number(this.totalBatchQty) != Number(itemQty))) {
      this.apiService.successAlert("Please ensure that the total quantity of batches matches the total quantity of this item.");
      return;
    }
    else if (this.data.Unit == '') {
      this.apiService.successAlert('Please enter a unit.');
      return;
    }
    else if (this.data.HSN != '' && this.data.HsnPer == '') {
      this.apiService.successAlert('Please enter a valid GST rate.');
      return;
    }
    else if(this.data.HsnPer && !this.data.HSN){
      this.apiService.successAlert('Please enter a valid HSN/SAC.');
      return;
    }
    // if(this.isEdit){
    //   this.data.mrpRate = ((this.BasicData.DefSaleRate) * (1 + (this.BasicData.DefGSTRate / 100))).toFixed(2);
    // }

    else {
      this.prcnQty();
      var tempData = [{
        'ItemID': this.data.ItemID,
        'ItemName': this.data.ItemName,
        'ItemCode': this.data.code,
        'TypeID': this.data.typeID,
        'Details': this.data.description,
        'CategoryID': this.data.categoryID,
        'SubCategoryID': this.data.SubCategoryID,
        'ISMade': this.data.IsMade,
        'IsPurchased': this.data.IsPurchased,
        'category': this.data.category,
        'CurrQty': this.data.Qty == '' ? 0 : this.data.Qty,
        'SKU': this.data.Unit,
        'DefPurchRate': this.data.purchaseCost == '' ? 0 : this.data.purchaseCost,
        'DefSaleRate': this.data.salePrice == '' ? 0 : this.data.salePrice,
        'DefStockRate': this.data.stockRate == '' ? 0 : this.data.stockRate,
        'MinStockQty': this.data.minStockQty == '' ? 0 : this.data.minStockQty,
        'IsAvailable': this.data.isAvailable == undefined ? true : this.data.isAvailable,
        'IsActive': this.data.isActive,
        'ImportanceID': this.data.importanceID,
        'HSNID': this.data.HSNId,
        'HSN': this.data.HSN,
        'ShowOnline': this.data.showOnline == undefined ? true : this.data.showOnline,
        'BrochureLink': this.data.brochureLink == undefined ? '' : this.data.brochureLink,
        'photos': '',
        'Tags': tag,
        'LeadTime': this.data.leadTime == '' ? 0 : this.data.leadTime,
        'storeBatches': this.storeBatches,
        'CurrStoreID': this.data.storeID == '' ? 1 : this.data.storeID,
        'HsnNo': this.data.HSN == undefined ? '' : this.data.HSN,
        'IGSTRate': this.data.HsnPer == undefined || this.data.HsnPer == null || this.data.HsnPer == '' ? 0 : (this.data.HsnPer + ""),
        'InternalNotes': this.data.internalNotes == undefined ? '' : this.data.internalNotes,
        'BatchType':this.data.batchTypeID,
        'Batches': this.batchList ? JSON.stringify(this.batchList) : '[]',
        'categoryRates': this.data.categoryRates ? this.data.categoryRates : '[]',
        'mrpRate': this.data.mrpRate ? this.data.mrpRate : 0,
        'mrpPrice': this.data.mrpPrice ? this.data.mrpPrice : 0,
        'InitQty': this.data.Qty == null || this.data.Qty == undefined ?  this.data.Qty : this.data.Qty,
        'InitUnit': this.data.Unit == null || this.data.Unit == undefined ? this.data.Unit : this.data.Unit,
        // 'Image': '1082_485_10-Apr-2023_16.47 A.M'
      }]
      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: MyLastSyncDT,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'set',
        moduleID: 5,
        data: JSON.stringify(tempData)
      }];
      this.loadingPnl.show();
      this.apiService.sendChangeForm(myParams, this.successVchrEntry.bind(this), this.failureResp.bind(this));
    }
  }

  //successVchrEntry - success voucher entry handler
  successVchrEntry(res: any) {
    // this.closeModel();
    let newItemID = 0
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      let doneObj = {
        action: 'Done',
        obj: res,
        IsMade: this.data.IsMade
      }
      let updatePackage: any = JSON.parse(res.updatePackage);
      newItemID = updatePackage.Table[0].ItemID;

      let agencyConfig = this.apiService.getCookie('Cfg_AgnCfg');
      if (agencyConfig) {
        agencyConfig = JSON.parse(agencyConfig);
        let fnllAgencyConfigData: any = [];
        fnllAgencyConfigData = agencyConfig;
        if (fnllAgencyConfigData.length > 0) {
          fnllAgencyConfigData[0].LastItemCode = this.data.code;
          if(updatePackage.Table[0].Billable){
            fnllAgencyConfigData[0].Billables = updatePackage.Table[0].Billable;
          }
        }
        this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(fnllAgencyConfigData));
      }
      else {
        let cookieData = [{
          LastItemCode: this.data.code
        }];
        this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(cookieData));
      }

      if(this.tagList.length > 0){
        let tag: string = "";
        for (let i = 0; i < this.tagList.length; i++) {
          tag = tag + this.tagList[i].trim() + ","
        }

        let erpConfig: any = this.apiService.getCookie('ERP_Cfg');
        let itemTags: string = "";
        if(erpConfig){
          erpConfig = JSON.parse(erpConfig);
          if(erpConfig.length > 0){
            itemTags = erpConfig[0].ItemTags;
          }
          itemTags = itemTags + "," + tag;
          erpConfig[0].ItemTags = itemTags;
          this.apiService.setCookie('ERP_Cfg', JSON.stringify(erpConfig));
        }
      }

     
      // this.batchList = []; 
      // // this.dataSer.updateBathesData(this.batchList)
      this.window.isSuccessItemEntry = 1;
      this.window.newItemID = newItemID;
      this.window.newItemName = this.data.ItemName;
      if(this.mdlRef){
        let tmpBatchDataList = {
          ItemID: 0,
          BatchType: 0,
          Batches: [],
          SKU:'',
          SKUPrecision: 0,
          transferQty: 0
        };
  
        this.dataSer.updateByProduct(tmpBatchDataList);
        this.batchList = []; 
        this.dataSer.updateBathesData(this.batchList)
        this.mdlRef.close(doneObj);
        this.getInvList();
      }
      else{
        this.window.close();
      }

      const isLive = this.apiService.fn_isLiveURL();
      if(this.showAsPage) {
        window.location.href = (isLive ? '/ERP': '') + "/Stock";
      }
      //      this.closeEntryModal();
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
    // this.closeModel();
    let doneObj = {
      action: 'Close',
      obj: null
    }
    //this.mdlRef.close(doneObj);


  }


  reset() {

    this.data = {
      ItemName: '',
      ItemID: 0,
      code: '',
      typeID: 1,
      categoryID: 0,
      subCategory: '',
      SubCategoryID: 0,
      category: '',
      Qty: '',
      Unit: 'no.s',
      purchaseCost: '',
      salePrice: '',
      stockRate: '',
      minStockQty: '',
      isAvailable: true,
      showOnline: true,
      isActive: true,
      importanceID: 1,
      HSN: '',
      HSNId: 0,
      brochureLink: '',
      fileLink: '',
      description: '',
      tag: '',
      leadTime: '',
      prcn: 0,
      storeName: '',
      storeID: '',
      internalNotes: '',
      categoryRates: '[]',
      mrpRate: 0,
      mrpPrice: 0
    }

    this.batchList = [];
    this.tagList = [];

  }


  closeModel() {
    // let doneObj = {
    //   action: 'Close',
    //   obj: null
    // }
    this.mdlRef.close();
    // this.activeModal.dismiss();
  }

  //remove tag from search
  removeTagSearch = (index: any) => {

    this.tagList.splice(index, 1)

  }


  getAllUnits() {
    let data: any = []

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'getConfig', 
      moduleID: 6,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successRespGet.bind(this), this.failureRespGet.bind(this));
  }

  //failureResp - failure handler
  failureRespGet(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }


  //successResp - success  get handler
  successRespGet(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let configData = reponseData.Table2;
          if (configData[0].Stores) {

            //Store List
            this.storeList = JSON.parse(configData[0].Stores)
            if (this.jarvisData[0].UserID !== this.agencyData[0].AdminUserID) {
              this.storeList = this.storeList.filter((store: any) => {
                // If no UIDs, everyone has access. If UIDs exists, check if user is included.
                return !store.UIDs || String(store.UIDs).split(',').includes(String(this.jarvisData[0].UserID));
              });
            }

            this.storeList = this.storeList.sort((a: any, b: any) => a.sNm.localeCompare(b.sNm))

            this.filterStore = this.StoreCtrl.valueChanges
              .pipe(
                startWith(''),
                map(x => x ? this._filterStore(x) : this.storeList.slice())
              );

            //unitlist
            this.UnitList = JSON.parse(configData[0].Units)
            this.UnitList = this.UnitList.sort((a: any, b: any) => a.UNm.localeCompare(b.UNm))

            this.filteredUnit = this.unitCtrl.valueChanges
              .pipe(
                startWith(''),
                map(x => x ? this._filterUnit(x) : this.UnitList.slice())
              );
            // this.data.Unit = this.UnitList[0].UNm
            // this.data.prcn = this.UnitList[0].Prcsn

            //HSN LIST
            this.hsnList = JSON.parse(configData[0].HSNSAC)
            this.hsnList = this.hsnList.sort((a: any, b: any) => a.H.localeCompare(b.H))

            this.filterHSN = this.HSNCtrl.valueChanges
              .pipe(
                startWith(''),
                map(x => x ? this._filterHSN(x) : this.hsnList.slice())
              );

            //Tag LIST
            let temp = configData[0].ItemTags

            let tempTags = temp.split(',')

            tempTags.forEach((s: any) => {
              let obj: any = {
                TID: '1',
                Tnm: s
              }
              this.mainTagList.push(obj)
            });
            this.mainTagList = this.mainTagList.sort((a: any, b: any) => a.Tnm.localeCompare(b.Tnm));
            this.mainTagList = this.mainTagList.filter((b: any) => b.Tnm != '');

            this.filterTag = this.TagCtrl.valueChanges
              .pipe(
                startWith(''),
                map(x => x ? this._filterTag(x) : this.mainTagList.slice())
              );

            //category List
            this.categories = JSON.parse(configData[0].ItemCategories)
            this.categories = this.categories.sort((a: any, b: any) => a.cnm.localeCompare(b.cnm))

            this.filteredCategory = this.categoryCtrl.valueChanges
            .pipe(
              startWith(''),
              map(cat => cat ? this._filterCategory(cat) : this.categories.slice())
            );

            // If I have only one category or sub-category configured, then show it pre-selected.
            if (this.categories.length == 1) {
              this.data.categoryID = this.categories[0].cid;
              this.data.category = this.categories[0].cnm;

              let subCtgList = this.categories[0].sub;
              if (subCtgList.length == 1) {
                this.data.subCategory = subCtgList[0].snm;
                this.data.SubCategoryID = subCtgList[0].sid
              }
            }


            // Batch Type
            this.filterBatch = this.batchCtrl.valueChanges
            .pipe(
              startWith(''),
              map(x => x ? this._filterBatch(x) : this.batchType.slice())
            );

            // Batch Type
            this.filterImportance = this.impItemCtrl.valueChanges
            .pipe(
              startWith(''),
              map(x => x ? this._filterImportance(x) : this.itemImportant.slice())
            );
            this.editData();

          }
        }

      }
    }
  }

  openStore() {
    this.modalReference = this.modalService.open(StoresComponent, { windowClass: 'modal-store-Entry', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.showOnlyAddModal = true;
    this.modalReference.result.then((result: any) => {
      if (result?.action == 'Done') {
        this.getAllUnits();
        //category List
        let cnfg;
        cnfg = this.apiService.getCookie('ERP_Cfg');
        if (cnfg) {
          cnfg = JSON.parse(cnfg);
          if (cnfg.length > 0) {
            this.store = JSON.parse(cnfg[0].Stores);
            this.store = this.store.sort((a: any, b: any) => a.cnm.localeCompare(b.cnm));
            this.getPrevCode();
          }
        }
        this.selectStore();
      }
    });
  }

  openUnit() {
    this.modalReference = this.modalService.open(UnitsComponent, { windowClass: 'modal-store-Entry', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.showOnlyAddModal = true;
    this.modalReference.result.then((result: any) => {
      if (result?.action == 'Done') {
        this.getAllUnits();
        //category List
        let cnfg;
        cnfg = this.apiService.getCookie('ERP_Cfg');
        if (cnfg) {
          cnfg = JSON.parse(cnfg);
          if (cnfg.length > 0) {
            this.store = JSON.parse(cnfg[0].Stores);
            this.store = this.store.sort((a: any, b: any) => a.cnm.localeCompare(b.cnm));
            this.getPrevCode();
          }
        }
      }
    });
  }

  openSubCat(content: any, id:any) {
    if(this.data.category == ""){
      this.apiService.successAlert("Please select a valid category.");
      return;
    }

    var CatData = this.categories.filter(function (element: any, index: any) {
      return (element.cid == id);
    });

    if(id != 0 && CatData[0].sub.length == 0 || CatData[0].sub.length > 0){
    this.modalReference = this.modalService.open(SubCategoriesComponent, { windowClass : "subCatSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.typeID = id;

    this.modalReference.componentInstance.CName = CatData[0].cnm;
    this.modalReference.componentInstance.mdlRef = this.modalReference;

    let sub = {
      cid: CatData[0].cid,
      sub: CatData[0].sub,
      cnm: CatData[0].cnm,
      categories: JSON.stringify(this.categories)
    }
    this.selectSubCategory();
    //this.router.navigate(['SubCategories']);
    this.dataSer.fn_dataTransfer(sub);
    $(".modal-content").css("display", "none !important");
  }
  }
  generateBarcode() {	
    //let prodCode = this.CmnService.encryptData(this.data.code);	
    let urlCheck: string = "";	
    const encodedCode = encodeURIComponent(this.data.code);
    const count = this.barcodeOptions.count;
    if (this.apiService.fn_isLiveURL() == true) {	
      urlCheck = `https://biziverse.com/Html/Popups/BarcodePrint.html?i=${encodedCode}&cnt=${count}`
   }	
 
   // urlCheck = `http://localhost:62854/Html/Popups/BarcodePrint.html?i=${encodedCode}&cnt=${count}`
    
    if (this.barcodeOptions.showName) {
      const encodedItemName = encodeURIComponent(this.data.ItemName);
      urlCheck += `&iN=${encodedItemName}`;
    }
    if (this.barcodeOptions.showPrice) {
      const encodedPrice = encodeURIComponent(this.data.salePrice);
      urlCheck += `&iP=${encodedPrice}`;
    }
    if(this.barcodeOptions.showMRP){
      const encodedMRP = encodeURIComponent(this.data.mrpPrice);
      urlCheck += `&mrp=${encodedMRP}`;
    }

    
    if(this.barcodeOptions.count < 1 || this.barcodeOptions.count > 15 || isNaN(this.barcodeOptions.count))
    {
      this.apiService.successAlert('Please enter number between 1-15.');
        return;
    }   
    const barcodeOptions = {
      showCode: this.barcodeOptions.showCode,
      showName: this.barcodeOptions.showName,
      showPrice: this.barcodeOptions.showPrice,
      showMRP: this.barcodeOptions.showMRP,
    };
    this.apiService.setCookie('barcodeOptions', JSON.stringify(barcodeOptions));
  
    const target = this.isWeb ? '_blank' : '_self';
    const win = window.open(urlCheck, target, 'left=400, top=150, height=250, width=500');
  }	

  uploadBiziFile() {	
    //let prodCode = this.CmnService.encryptData(this.data.code);	
    let urlCheck: string = "";	
    urlCheck += "https://biziverse.com/main.html#/BiziFiles?i=" + this.data.ItemID; 	
    	
    let target: string = "_blank";	
    if(this.isWeb == false){  	
      target = "_self";	
    }	
    this.initInterval();
    this.win = window.open(urlCheck, target, 'left=500, top=150, height = 350, width = 420');	
  	
  }	

  showFiles() {
    //let prodCode = this.CmnService.encryptData(this.data.code);
    let urlCheck: string = "";
    //if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "https://biziverse.com/main.html#/BiziFiles?i=" + this.data.ItemID;
    //}
    //urlCheck += "http://localhost:62854/main.html#/BiziFiles?i=" + this.data.ItemID;
    
    let target: string = "_blank";
    if(this.isWeb == false){  
      target = "_self";
    }
    var win: any = window.open(urlCheck, target, 'left=400, top=150, height = 350, width = 700');
  }
  
  

initInterval=()=> {
  let timer = setInterval(()=> {
      if (this.win.isDataGet) {
          clearInterval(timer);
          this.ckeckImg(this.win.itemID, this.win.image);                     
          this.win.close();
      }
      if (this.win.closed) {
          clearInterval(timer);
          this.ckeckImg(this.win.itemID, this.win.image);
      }
  }, 100);
}

ckeckImg = (id:any, image:any)=> {
      if (this.data.ItemID == id && image != '') {
        this.hasImg == true;
      }
  this.win.isDataGet = 0;
  this.win.itemID = 0;
  this.win.image = "";
}


  // getRelCategories() - Get all categories from cookie
  getRelCategories(){
      this.orgCategotyList = [];
      let agnData = this.apiService.getCookie('Cfg_AgnCfg');
      if (agnData) {
        let tmpAgnData: any = JSON.parse(agnData);
        if (tmpAgnData.length > 0) {
          let tmpCatData: any = tmpAgnData[0].RelCategories;
          if(tmpCatData){
            this.orgCategotyList = JSON.parse(tmpCatData);
            this.orgCategotyList = this.orgCategotyList.filter((b: any) => b.IsD == false);
          }       
        }
      }
      if(this.orgCategotyList.length > 0){
        this.isShowCatWiseRateBtn = true;
      }
      else{
        this.isShowCatWiseRateBtn = false;
      }
  }

  // setRates() - Set rates fro new item or edit category
  setRates(id: any){
    this.getRelCategories()
    if(id == 1){
      if(this.orgCategotyList.length > 0){
        this.isShowCatWiseRateBtn = true;
        this.isShowPropose = true;
        if(!this.isRateEdit){
          this.categoryList = [];
          this.orgCategotyList.forEach((c: any) => {
            let rate = {
              CID: c.CID,
              CNm: c.CNm,
              D: '',
              IsD: false
            }
            this.categoryList.push(rate)
          }); 
          this.categoryList = this.categoryList.sort((a: any, b: any) => a.CNm.localeCompare(b.CNm));
        }     
      }
      else{
        this.isShowCatWiseRateBtn = false;
        this.isShowPropose = false;
      }
    }
    else{
      let itemRateData = this.data.categoryRates;
      if(itemRateData){
        let itemCatData = JSON.parse(itemRateData)
        if(itemCatData.length > 0){
          this.isShowPropose = false;
          if(!this.isRateEdit){
            this.categoryList = [];
            this.orgCategotyList.forEach((c: any) => {
            let itemCats = itemCatData.filter((b: any) => b.CID == c.CID);
            if(itemCats.length > 0){
              let rate = {
                CID: itemCats[0].CID,
                CNm: c.CNm,
                D: itemCats[0].D,
                IsD: false
              } 
              this.categoryList.push(rate)            
            }
            else{
              let rate = {
                CID: c.CID,
                CNm: c.CNm,
                D: '',
                IsD: false
            } 
            this.categoryList.push(rate)
          }       
          });

          this.categoryList = this.categoryList.sort((a: any, b: any) => a.CNm.localeCompare(b.CNm));
          }     
        }
        else{
          this.isShowPropose = true;
          this.categoryList = [];        
          this.orgCategotyList.forEach((c: any) => {
            let rate = {
              CID: c.CID,
              CNm: c.CNm,
              D: '',
              IsD: false
            }
            this.categoryList.push(rate)
          }); 
          this.categoryList = this.categoryList.sort((a: any, b: any) => a.CNm.localeCompare(b.CNm)); 
        }
      }
    }
  }

  // openCategoryWiseRateMdl() - open category rate modal
  openCategoryWiseRateMdl(content:any){
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'dateFilter', backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
      //get category
      if(this.data.ItemID == 0){
        this.setRates(1)
      }
      else{
        this.setRates(2)
      }   
  }

  //saveCatRate() - Set final array for save
  saveCatRate(){
    let finalItemCtgData: any = [];
    var flag = false;
    if (this.categoryList) {
      for (var i = 0; i < this.categoryList.length; i++) {
        if (this.categoryList[i].D == '' || this.categoryList[i].D > 100 || this.categoryList[i].D < 0) {
          flag = true
          this.apiService.successAlert("Please enter a valid discount for " + this.categoryList[i].CNm + ".");
          break;
        }
        else{
          let rate = {
            CID: this.categoryList[i].CID,
            D: this.categoryList[i].D
          }
          finalItemCtgData.push(rate)
        }
      }
    }
    if (!flag) {
      this.data.categoryRates = JSON.stringify(finalItemCtgData);
      this.isRateEdit = true;
      this.modalReference.close();
    } 
  }

  // proposeDiscount() - Propose customer wise rate for item
  proposeDiscount() {
    this.categoryList.forEach((c: any) => {
      let rateData: any = $.grep(this.orgCategotyList, function(o: any){ return o.CID == c.CID });
      if(rateData.length > 0){
        c.D = rateData[0].D;
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  setDiscount (c: any){
    c.D = this.CmnService.PrecisionwiseValue(c.D, 2)
  }


  //def. stock rate
  fn_changeMRPRate = () => {
      this.isMRPChanged = false;
      this.gstRate = Number(this.data.HsnPer);
      this.data.mrpRate = Number(this.data.salePrice * this.gstRate);
      this.data.mrpRate = Number(((Number(this.data.mrpRate) / 100) + Number(this.data.salePrice)).toFixed(2));
  }

  openBarcodeOptions(content:any){
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'dateFilter', backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }
  
  revCalculateMRP() {
    this.isMRPChanged = true;
    this.gstRate = Number(this.data.HsnPer);
    this.gstRate = (Number(this.gstRate) / 100) + 1;
    this.data.salePrice = Number(((Number(this.data.mrpRate)) / this.gstRate).toFixed(2));
  }

  // fn_discountCountMrp = () => {
  //     this.data.HsnPer =  this.CmnService.PrecisionwiseValue(this.data.HsnPer + "", 2);
  //     this.data.SubTotal = this.data.Qty * this.data.mrpRate
  //     this.data.DiscountAmt =(this.data.SubTotal * this.data.HsnPer / 100).toFixed(2);
  // }

  fn_gstCount = () => 
  {
    if (this.data.HsnPer > 40 ) {
      this.data.HsnPer = 0;
      this.apiService.successAlert("Please enter a valid GST rate.")
    }

    if(this.data.salePrice && !this.isMRPChanged) {
      this.gstRate = Number(this.data.HsnPer);
      this.data.mrpRate = Number(this.data.salePrice * this.gstRate);
      this.data.mrpRate = Number(((Number(this.data.mrpRate) / 100) + Number(this.data.salePrice)).toFixed(2));
    }
    
     if (this.data.salePrice && this.isMRPChanged) {
      this.gstRate = Number(this.data.HsnPer);
        this.data.salePrice = Number(this.data.mrpRate * this.gstRate);
        this.data.salePrice = Number(((this.data.salePrice) / 100) + Number(this.data.mrpRate)).toFixed(2);
    }

    if(this.data.mrpRate && this.isMRPChanged) {
      this.gstRate = Number(this.data.HsnPer);
      this.gstRate = (Number(this.gstRate) / 100) + 1;
      this.data.salePrice = Number((this.data.mrpRate) / this.gstRate).toFixed(2);
    }
  }

  closeModal($event: any) {
    this.modalReference.close();
    if ($event) {
        this.changingValue.next($event);
    }
  }

  backToHomeBtn() {
    this.loadingPnl.show();
    window.location.href = "https://biziverse.com/main.html#/home";
  }
  toggleCheckbox(option: string): void {
    if (option === 'price') {
      if (this.barcodeOptions.showPrice) {
        this.barcodeOptions.showMRP = false; // Uncheck MRP if Price is checked
      }
    } else if (option === 'mrp') {
      if (this.barcodeOptions.showMRP) {
        this.barcodeOptions.showPrice = false; // Uncheck Price if MRP is checked
      }
    }
  }

  collapseDiv() {
    this.expand.extraDetails = !this.expand.extraDetails;
  }; 
}
export interface category {

  cid: number;
  cnm: string;
  sub: any[];
}

export interface subCategory {
  sid: number;
  snm: string;
}

export interface units {
  UID: number;
  UNm: string;
  Prcsn: number;
}


export interface store {
  StrID: number;
  sNm: string;
  uIDs: any[];
}


export interface HSN {
  HID: number;
  H: string;
  C: string;
  Per: number
}


export interface Tags {
  TID: number;
  Tnm: string;
}

export interface BatchType {
  val: number;
  type: string;
}
export interface itemImportant {
  val: number;
  itemType: string;
}

